import { Injectable } from '@angular/core';
import { ApiBase } from './api.base';
import { HttpClient } from '@angular/common/http';
import { Tso } from 'ts-odata';
import { Observable } from 'rxjs';

@Injectable()
export class PedidosApi extends ApiBase {

  constructor(http: HttpClient) {
    super(http, 'pedidos');
  }

  createListQuery(): Tso {
    return new Tso("buscar/lista");
  }
  createCsvQuery(): Tso {
    return new Tso("buscar/csv");
  }

  getCsv(query: Tso): Observable<any> {
    let q = this.preparaOdataQuery(true, query);
    return this.doGet(q, { observe: 'response', responseType: "blob" });
  }
}


